import {type RecordOf, Record, List, Map, Set} from 'immutable';

import type {
  ActionId,
  ActionListId,
  InteractionId,
} from '@packages/systems/ix2/types-core';
import {type NativeId} from '@packages/systems/core/utils/NativeIdUtils';

import type {InteractionsRecordType} from './trigger-interactions-immutable';
import type {
  ActionListsRecordType,
  ActionListRecordType,
} from './animation-actionlist-immutable';
import type {EventTRecordypes} from './trigger-events-immutable';

/**
 * Immutable version of IX2 store state
 */
type IX2StateRecordType = {
  interactions: InteractionsRecordType;
  actionLists: ActionListsRecordType;
  events: EventTRecordypes;
  selectedInteractionId: null | InteractionId;
  selectedTargetIndex: null | number;
  selectedInteractionElementId: null | string;
  selectedActionItemIds: List<ActionId>;
  selectedActionListId: null | ActionListId;
  relinkMode: boolean;
  nodeIdMap: Map<string, string>;
  keepActive: boolean;
  actionItemIsEphemeral: boolean;
  stagedActionList: null | ActionListRecordType;
  initialFocusedSymbolNativeIdPath: null | NativeId[];
  initialSelectedNodeInInstanceNativeIdPath: null | NativeId[];
  baseActionListIds: Set<string>;
  baseEventIds: Set<string>;
  baseInteractionIds: Set<string>;
  branchId: string | null;
};

export type IX2StoreStateType = RecordOf<IX2StateRecordType>;

/**
 * Immutable version of IX2 store state
 */
export const IX2StateRecord = Record<IX2StateRecordType>(
  {
    events: List([]),
    actionLists: List([]),
    interactions: List([]),

    selectedInteractionId: null,
    selectedTargetIndex: null,
    selectedInteractionElementId: null,
    selectedActionItemIds: List([]),
    selectedActionListId: null,

    relinkMode: false,
    nodeIdMap: Map(),
    keepActive: false,
    actionItemIsEphemeral: false,
    stagedActionList: null,
    initialFocusedSymbolNativeIdPath: null,
    initialSelectedNodeInInstanceNativeIdPath: null,

    baseActionListIds: Set(),
    baseEventIds: Set(),
    baseInteractionIds: Set(),
    branchId: null,
  },
  'IX2StateRecord'
);
